module.exports = __webpack_public_path__ + "static/JodyCircle-fa608623c469bbe2f53de14435fc6346.png";